// extracted by css-extract-rspack-plugin
export default {"debug":"debug-rd3mDr","branchName":"branchName-OOW6zd","commitSha":"commitSha-kdrWrT"};